(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
        const testimonials = document.querySelectorAll(".testimonial-shuffle .testimonial");
        if (testimonials.length === 0) return;

        let currentIndex = 0;

        testimonials.forEach((testimonial, index) => {
            if (index === 0) {
                testimonial.classList.add("active");
            } else {
                testimonial.classList.remove("active");
            }
        });

        setInterval(() => {
            // Remove active class from current testimonial
            testimonials[currentIndex].classList.remove("active");

            // Move to next testimonial (cycle back to first when reaching the end)
            currentIndex = (currentIndex + 1) % testimonials.length;

            // Add active class to new current testimonial
            testimonials[currentIndex].classList.add("active");
        }, 5000);
    });
  } catch(e) { console.error(e); }
})();

})();
